import {createContext, Dispatch, FC, Reducer, useReducer} from "react";
import {IFlow, IFlowExecution} from "../types/ApiTypes";

const initialData = {
    flows: [],
    policies: []
};

interface State {
    flows: IFlow[],
    policies: IFlowExecution[]
}

type Actions =
    {type: 'SET_FLOWS', payload: IFlow[]}|
    {type: 'APPEND_FLOW', payload: IFlow}|
    {type: 'UPDATE_FLOW', payload: {updatedFlow: IFlow, flowId: number }}|
    {type: 'REMOVE_FLOW', payload: number}|
    {type: 'SET_POLICIES', payload: IFlowExecution[]}|
    {type: 'APPEND_POLICY', payload: IFlowExecution}|
    {type: 'DELETE_POLICY', payload: number}|
    {type: 'UPDATE_POLICY', payload: {updatedPolicy: IFlowExecution, policyId: number} }

const AdminReducer: Reducer<State, Actions> = (state,action) => {
    switch (action.type) {
        case "SET_FLOWS": return {
            ...state,
            flows: action.payload
        }
        case "APPEND_FLOW": return {
            ...state,
            flows: [...state.flows, action.payload]
        }
        case 'UPDATE_FLOW':
            const flows = state.flows.concat();
            const flow = flows.find(x => x.id === action.payload.flowId);
            if(!flow) throw new Error('Update method called with undefined flow URL');
            flow.name = action.payload.updatedFlow.name;
            flow.url = action.payload.updatedFlow.url;
            return {
                ...state,
                flows: flows
            }
        case 'REMOVE_FLOW':
            let flowsCopy = state.flows.concat();
            flowsCopy = flowsCopy.filter(x => x.id !== action.payload);
            return {
                ...state,
                flows: flowsCopy
            }
        case 'SET_POLICIES': return {
            ...state,
            policies: action.payload
        }
        case "APPEND_POLICY": return {
            ...state,
            policies: [...state.policies, action.payload]
        }
        case "DELETE_POLICY":
            const filteredPolicies = state.policies.filter(x => x.id !== action.payload);
            return {
                ...state,
                policies: filteredPolicies
            }
        case "UPDATE_POLICY":
            const policies = state.policies.concat();
            const policy = policies.find(x => x.id === action.payload.policyId);
            if(!policy) throw new Error('Update method called with undefined flow URL');
            policy.order = action.payload.updatedPolicy.order;
            policy.action = action.payload.updatedPolicy.action;
            policy.group_type = action.payload.updatedPolicy.group_type;
            policy.flow = action.payload.updatedPolicy.flow || policy.flow;
            policy.isDisabled = action.payload.updatedPolicy.isDisabled ?? policy.isDisabled;
            policy.extraPayload = action.payload.updatedPolicy.extraPayload ?? policy.extraPayload;
            return {
                ...state,
                policies: policies
            }
    }
}

export const AdminContext = createContext<{
    state: State,
    dispatch: Dispatch<Actions>
}>({
    state: initialData,
    dispatch: (payload: Actions) => {}
});

export const AdminProvider: FC = ({children}) => {
    const [state,dispatch] = useReducer(AdminReducer, initialData);
    return (
        <AdminContext.Provider value={{
            state,
            dispatch
        }}>{children}</AdminContext.Provider>
    )
}